//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shopName:'',
      manager:'全部',
      managerList:[],
      tableData:[],
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:10,
      total:0,
      pageNo:1,
      // 店铺类型 0原来茶楼1供应商茶楼
      shopType:1,
      shopTypeList:[
        {value:0,key:'平台店铺'},
        {value:1,key:'我的店铺'},
      ],
      routerShopType:1,
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
        dealerId:window.sessionStorage.getItem('dealerId'),
        shopType:this.shopType
      }
      this.routerShopType = this.shopType
      if(this.shopName !== ''){
        data.shopName = this.shopName
      }
      if(this.manager !== '全部' && this.shopType === 1)
        data.dStaffId = this.manager
      this.$axios.post('/mtea/stock/dealer/indexSearch', data).then(res => {
        this.tableData = res.list.records
        this.total = res.list.total
        this.managerList = res.staffs
        for(let i = 0;i<res.list.records.length;i++){
          let state = 0
          for(let j = 0;j<res.staffs.length;j++){
            if(res.list.records[i].dStaffId === res.staffs[j].dStaffId){
              state++
              break
            }
          }
          if(!state) res.list.records[i].dStaffName = '无'
        }
        this.managerList.unshift({dStaffId:'全部',dStaffName:'全部'})
      })
    },
    handleClick(row){
      if(this.routerShopType === 0)
      window.sessionStorage.setItem('shopMsg',JSON.stringify(row))
      this.$router.push({name:'details',query:{shopId:row.dShopId,dStaffName:row.dStaffName,shopType:this.routerShopType.toString()}})
    },
    cellStyel(){
      let style = {}
      style['text-align'] = 'center'
      return style
    },
    headerCellStyel(){
      let style = {}
      style['text-align'] = 'center'
      style['background-color'] = '#f2f2f2'
      return style
    },

    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
  },
}
